import { z } from "zod"

export type LanguageLevel =
  | "a0"
  | "a1"
  | "a1_minus"
  | "a2"
  | "a2_minus"
  | "b1"
  | "b1_minus"
  | "b2"
  | "b2_minus"
  | "c1"
  | "c2"

export const levelOptions: { value: LanguageLevel; label: string }[] = [
  { value: "a0", label: "A0" },
  { value: "a1_minus", label: "A1-" },
  { value: "a1", label: "A1" },
  { value: "a2_minus", label: "A2-" },
  { value: "a2", label: "A2" },
  { value: "b1_minus", label: "B1-" },
  { value: "b1", label: "B1" },
  { value: "b2_minus", label: "B2-" },
  { value: "b2", label: "B2" },
  { value: "c1", label: "C1" },
  { value: "c2", label: "C2" },
]

export const AlphaLevelOptions = [
  { value: "alfa", label: "Alfa" },
  { value: "alfa_a", label: "Alfa A" },
  { value: "alfa_b", label: "Alfa B" },
  { value: "alfa_c", label: "Alfa C" },
  ...levelOptions,
]

export const levelLabelMap = Object.fromEntries(
  levelOptions.map((opt) => [opt.value, opt.label]),
) as Record<string, string>

export const targetlevelOptions: { value: TargetLevelEnum; label: string }[] = [
  { value: "self_reliance", label: "Zelfredzaamheid" },
  { value: "a2", label: "A2" },
  { value: "b1", label: "B1" },
  { value: "b2", label: "B2" },
  { value: "nvt", label: "N.V.T." },
]

export const targetLevelLabelMap = Object.fromEntries(
  targetlevelOptions.map((opt) => [opt.value, opt.label]),
) as Record<string, string>

export const targetLevelSchema = z.enum([
  "self_reliance",
  "a2",
  "b1",
  "b2",
  "nvt",
])
export type TargetLevelEnum = z.infer<typeof targetLevelSchema>

export const learningPathPipOptions: {
  value: LearningPathPipEnum
  label: string
}[] = [
  { value: "b1_route", label: "B1 Route" },
  { value: "b1_route_entree", label: "B1 Route Entree" },
  { value: "z_route", label: "Z-Route" },
]

export const learningPathPipLabelMap = Object.fromEntries(
  learningPathPipOptions.map((opt) => [opt.value, opt.label]),
) as Record<string, string>

export const learningPathPipEnumSchema = z.enum(
  ["b1_route", "b1_route_entree", "z_route"],
  {
    message: "Leerroute PIP is verplicht",
  },
)

export type LearningPathPipEnum = z.infer<typeof learningPathPipEnumSchema>
